import {
  CreateAccommodationRequestBody,
  CreateAttractionRequestBody,
  CreateRestaurantBarRequestBody,
} from 'src/tripPlanner/utils/itemConversions/common'
import { ExploreItem } from 'tripPlanner/types/common'

export interface Params {
  exploreItem: ExploreItem
  type:
    | CreateAttractionRequestBody['type']
    | CreateRestaurantBarRequestBody['type']
    | CreateAccommodationRequestBody['type']
  startDate?: string
}

export function createExploreItemBookmarkPayload({
  exploreItem,
  type,
  startDate,
}: Params):
  | CreateAttractionRequestBody
  | CreateRestaurantBarRequestBody
  | CreateAccommodationRequestBody {
  if (type === 'ACCOMMODATION') {
    return {
      type,
      place: {
        type: 'GEO',
        name: exploreItem.name,
        address: exploreItem.place.address,
        photoUrl: exploreItem.photo?.photoUri,
        id: exploreItem.place.id,
        region: exploreItem.place.region,
        editorialSummary: exploreItem.editorialSummary,
        priceLevel: exploreItem.priceLevel,
        point: {
          lat: exploreItem.place.point.lat,
          lng: exploreItem.place.point.lng,
        },
      },
      phone: exploreItem.phone,
      sourceType: 'NA', // Should be source type search too?
      status: 'PLANNED',
      url: exploreItem.website,
      isBooked: false,
      startDate,
    }
  }
  return {
    type,
    place: {
      type: 'GEO',
      name: exploreItem.name,
      address: exploreItem.place.address,
      photoUrl: exploreItem.photo?.photoUri,
      id: exploreItem.place.id,
      region: exploreItem.place.region,
      editorialSummary: exploreItem.editorialSummary,
      priceLevel: exploreItem.priceLevel,
      point: {
        lat: exploreItem.place.point.lat,
        lng: exploreItem.place.point.lng,
      },
    },
    phone: exploreItem.phone,
    sourceType: 'Explore',
    status: 'PLANNED',
    url: exploreItem.website,
    code: exploreItem.place.id,
    isBooked: false,
    startDate,
  }
}
